import type { AccessibilitySettings } from '../types'
import { AccessibilityToolbar } from './AccessibilityToolbar'

interface Props {
  settings: AccessibilitySettings
  onSettingsChange: (settings: AccessibilitySettings) => void
  onHome?: () => void
}

export function AppHeader({ settings, onSettingsChange, onHome }: Props) {
  return (
    <header className="app-header">
      <button type="button" className="brand-button" onClick={onHome} disabled={!onHome}>
        <img src="/assets/logo-ihlc.png" alt="Logotipo del Instituto de Humanidades Luis Campino" />
        <span>
          <strong>Laboratorio de Historia</strong>
          <small>Aprendizaje interactivo</small>
        </span>
      </button>
      <AccessibilityToolbar settings={settings} onChange={onSettingsChange} />
    </header>
  )
}
